var chunkToChildrenMap = {
	"3554": [
		5244,
		8928,
		4728,
		9135,
		4886
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));